import * as R from 'ramda';
import { Endpoints } from '../../../../core/api/endpoints';
import { ApiReducer, makeApiReducer, makeApiAction, makeRsaaTypes } from '../../../../core/api/rsaa';
import { addError, noLoadingNoError, addLoading, getLoading } from '../../../../core/api/module';
import { ActionType } from '../../../../core/redux/actionType';
import { StatusKey } from '../../models';


const KEY_ACTION = ActionType.GetStatusKeysRequest;
const ACTIONS    = [
  ActionType.GetStatusKeysRequest,
  ActionType.GetStatusKeysResponse,
  ActionType.GetStatusKeysError,
];


type Payload = StatusKey[];


/**
 * Dispatch this action to get a list of the statuses a dev plan item action can have (not started, in progress,
 * complete)
 */
export const getDevPlanStatusesAction = () => makeApiAction<Payload>({
  method:   'POST',
  endpoint: Endpoints.GetStatusKeys,
  headers:  { 'content-type': 'application/json' },
  body:     '',
  types:    makeRsaaTypes<Payload>(ACTIONS),
  bailout:  state => !!getLoading(state, KEY_ACTION),
});


const reducer: ApiReducer<Payload> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg);
  }

  const successState = noLoadingNoError(state, KEY_ACTION);

  return R.assocPath(['devPlan', 'actionStatuses'], payload, successState);
};


export const getDevPlanStatusesReducer = makeApiReducer<Payload>(ACTIONS, KEY_ACTION, reducer);
